export default Backbone.Model.extend({
  // This is a model which takes in a source model and reflects any
  // changes made to it.  It will also send any changed
  constructor(options) {
    this.source = options.source;
    Backbone.Model.prototype.constructor.call(this, this.source.toJSON(), options);
  },

  initialize() {
    this.source.on('change', _.bind(this.onSourceChanged, this));
  },

  reset() {
    this.set(this.source.toJSON());
  },

  send() {
    this.source.set(this.toJSON());
  },

  onSourceChanged() {
    this.set(this.source.changedAttributes());
  },
});



// WEBPACK FOOTER //
// ./js/backbone/models/search/proxy_model.js